import React from 'react';

import LazyLoadedImage from 'common/LazyLoadedImage';
import nbspLastSpace from 'common/util/nbspLastSpace';

export type LandingPointProps = {
  image: {
    src: string;
    alt: string;
  };
  title: string;
  subtitle: string;
  loadImageEagerly?: boolean;
  points: (string | React.ReactNode)[];
};

const LandingPoint = ({
  image,
  title,
  subtitle,
  loadImageEagerly = false,
  points,
}: LandingPointProps) => {
  return (
    <article className="point">
      <LazyLoadedImage
        src={image.src}
        alt={image.alt}
        loading={loadImageEagerly ? 'eager' : 'lazy'}
      />
      <div className="text">
        <h2 className="title">{nbspLastSpace(title)}</h2>
        <p>{nbspLastSpace(subtitle)}</p>
        <ul className="pointList">
          {points.map((copy, index) => {
            return (
              <li key={index}>
                <p>{typeof copy === 'string' ? nbspLastSpace(copy) : copy}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </article>
  );
};

export default LandingPoint;
